/* eslint max-len:off */

import FeedbackDetailList from '@ebay/feedback-components/src/components/feedback-detail-list/index.marko';
import FeedbackDetailSellerRating from '@ebay/feedback-components/src/components/feedback-detail-seller-rating/index.marko';
import FeedbackOverallRating from '@ebay/feedback-components/src/components/feedback-overall-rating/index.marko';
import StrAboutDescription from '../str-about-description';
import StrAboutPolicies from '../str-about-policies';
import StrAboutVideo from '../str-about-video';
import StrBusinessDetails from '../str-business-details';
import StrCategoryCarousel from '../str-category-carousel';
import StrContactSeller from '../str-contact-seller';
import StrCharity from '../str-charity';
import StrItemsCarousel from '../str-items-carousel';
import StrItemsGrid from '../str-items-grid';
import StrMarketingBanner from '../str-marketing-banner';
import StrMarketingBannerCarousel from '../str-marketing-banner-video';
import StrRecommendedStrip from '../str-recommended-strip';
import StrSellerComms from '../str-seller-comms';
import StrStatusInlineModule from '../str-status';
import StrStatusModule from '../str-status';

// Only add components that should be rendered in the order and
// placement set by meta.pageTemplate in the service model.
// For instance ITEMS_GRID is added as it should follow the
// placement set by meta.pageTemplate. But the SORT_ITEMS_SELECTION
// is not added because it's composed into other modules.
export default {
    ABOUT_DESCRIPTION_V2: StrAboutDescription,
    ABOUT_STORE_POLICIES: StrAboutPolicies,
    ABOUT_VIDEO: StrAboutVideo,
    BUSINESS_DETAILS: StrBusinessDetails,
    CHARITY: StrCharity,
    CONTACT_SELLER: StrContactSeller,
    FEEDBACK_DETAIL_LIST: FeedbackDetailList,
    FEEDBACK_DETAILED_SELLER_RATING_SUMMARY: FeedbackDetailSellerRating,
    FEEDBACK_OVERALL_RATING_SUMMARY: FeedbackOverallRating,
    ITEMS_CAROUSEL_V2: StrItemsCarousel,
    ITEMS_CAROUSEL_V3: StrItemsCarousel,
    ITEMS_GRID: StrItemsGrid,
    MARKETING_BANNER_V2: StrMarketingBanner,
    MARKETING_BANNER_3D: StrMarketingBanner,
    MARKETING_BANNER_CAROUSEL: StrMarketingBannerCarousel,
    MFE_DELI_REQUEST: StrRecommendedStrip,
    NAVIGATION_CAROUSEL_V2: StrItemsCarousel,
    NAVIGATION_PILLS: StrCategoryCarousel,
    SELLER_COMMS: StrSellerComms,
    STATUS_MESSAGE: StrStatusModule,
    STATUS_MESSAGE_INLINE_CTA: StrStatusInlineModule
};
